export default __webpack_public_path__ + "static/media/small-prev-white-icon.577e8b49.svg";